import React from 'react';
import PropTypes from 'prop-types';
import { Paper, List, Subheader, Toggle } from 'material-ui';
import style from '../../../styles/styles';
import styles from './CommentSetting.css';
import Loading from '../../common/Loading/Loading';
import withTranslation from '../../../hoc/withTranslation';

class CommentSetting extends React.Component {
    static propTypes = {
        app: PropTypes.object,
        editConfiguration: PropTypes.func,
    };

    static defaultProps = {
        app: null,
        loading: false,
    };

    handleToggledCommentValidation = (event, isInputChecked) => {
        this.props.editConfiguration('comment_validation', isInputChecked);
    };

    handleToggledCommentNeeded = (event, isInputChecked) => {
        this.props.editConfiguration('comment_needed', isInputChecked);
    };

    handleToggledAccountNeeded = (event, isInputChecked) => {
        this.props.editConfiguration('account_needed', isInputChecked);
    }

    handleToggledNoteNeeded = (event, isInputChecked) => {
        this.props.editConfiguration('note_needed', isInputChecked);
    };

    handleToggledMultiComment = (event, isInputChecked) => {
        this.props.editConfiguration('multi_comment', isInputChecked);
    };

    handleToggledSendCommentValidationAdminMail = (event, isInputChecked) => {
        this.props.editConfiguration('send_comment_validation_admin_mail', isInputChecked);
    };

    render() {
        const {
            loading,
            app,
        } = this.props;
        let content;
        if (loading) {
            content = <Loading paper={false} />;
        } else {
            content = (
                <div>
                    <Toggle
                        style={styles.toggle}
                        label={this.props.t('settings_page.comments_validation_settings')}
                        toggled={app.configurations.comment_validation}
                        labelPosition="right"
                        onToggle={this.handleToggledCommentValidation}
                    />
                    <Toggle
                        style={styles.toggle}
                        label={this.props.t('settings_page.comment_needed_settings')}
                        toggled={app.configurations.comment_needed}
                        labelPosition="right"
                        onToggle={this.handleToggledCommentNeeded}
                    />
                    <Toggle
                        style={styles.toggle}
                        label={this.props.t('settings_page.note_needed_settings')}
                        toggled={app.configurations.note_needed}
                        labelPosition="right"
                        onToggle={this.handleToggledNoteNeeded}
                    />
                    <Toggle
                        style={styles.toggle}
                        label={this.props.t('settings_page.multi_comments_settings')}
                        toggled={app.configurations.multi_comment}
                        labelPosition="right"
                        onToggle={this.handleToggledMultiComment}
                    />
                    <Toggle
                        style={styles.toggle}
                        label={
                            this.props.t('settings_page.send_comment_validation_admin_mail_setting')
                        }
                        toggled={app.configurations.send_comment_validation_admin_mail}
                        labelPosition="right"
                        onToggle={this.handleToggledSendCommentValidationAdminMail}
                    />
                    <Toggle
                        label={
                            this.props.t('settings_page.account_needed_settings')
                        }
                        toggled={app.configurations.account_needed}
                        labelPosition="right"
                        onToggle={this.handleToggledAccountNeeded}
                    />
                </div>
            );
        }

        return <Paper>
            <List>
                <Subheader style={{ ...style.subHeader, ...style.relative }}>
                    {this.props.t('module.comment.name')}
                </Subheader>

                <div style={style.paper}>
                    {content}
                </div>
            </List>
        </Paper>;
    }
}

export default withTranslation(CommentSetting);



// WEBPACK FOOTER //
// src/components/common/CommentSetting/CommentSetting.js